export interface DataType {
  key: string;
  icon?: string;
  marketplace: string;
  impressions: number;
  clicks: number;
  orders: number;
  cvr: string;
  sales: string;
  salesShare: string;
  spend: string;
  acos: string;
  roi: string;
  cpc: string;
  cac: string;
  children?: DataType[];
}

export interface TableSettings {
  visibleChannels: {
    amazonUSA: boolean;
    shopify: boolean;
    tiktokShop: boolean;
  };
  visibleMetrics: {
    impressions: boolean;
    clicks: boolean;
    orders: boolean;
    cvr: boolean;
    sales: boolean;
    salesShare: boolean;
    spend: boolean;
    acos: boolean;
    roi: boolean;
    cpc: boolean;
    cac: boolean;
  };
}

export const defaultSettings: TableSettings = {
  visibleChannels: {
    amazonUSA: true,
    shopify: true,
    tiktokShop: true,
  },
  visibleMetrics: {
    impressions: true,
    clicks: true,
    orders: true,
    cvr: true,
    sales: true,
    salesShare: true,
    spend: true,
    acos: true,
    roi: true,
    cpc: true,
    cac: true,
  },
};
